import { Col, Row } from "components/primitives";
import Form from "react-bootstrap/Form";
import styled from "styled-components";
import { WidgetSettingFC } from "types/Setting";

interface ToggleInfo {
  label: string;
  noMargin?: boolean;
  infoMessage?: string;
}

export const ToggleSetting: WidgetSettingFC<boolean, ToggleInfo> = ({
  data: isChecked,
  setData,
  info: { label, noMargin = false, infoMessage },
}) => {
  return (
    <OuterContainer noMargin={noMargin}>
      <p>{label}</p>
      <InnerContainer>
        <Switch>
          <Form.Control checked={isChecked} type="checkbox" onChange={() => setData(!isChecked)} />
          <Slider />
        </Switch>
        <span>{isChecked ? "Enabled" : "Disabled"}</span>
      </InnerContainer>

      {isChecked && infoMessage ? <TextMessage>{infoMessage}</TextMessage> : null}
    </OuterContainer>
  );
};

const OuterContainer = styled(Col)<{ noMargin: boolean }>`
  margin-bottom: ${(props) => (props.noMargin ? "0px" : "35px")};

  p {
    margin-bottom: 16px;
    font-weight: 600;
    font-size: 12pt;
  }
`;

export const InnerContainer = styled(Row)`
  align-items: center;
  gap: 10px;

  span {
    color: var(--gray);
  }
`;

export const Slider = styled.span`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
  border-radius: 26px;

  :before {
    position: absolute;
    content: "";
    height: 80%;
    aspect-ratio: 1;
    left: 0;
    top: 50%;
    transform: translate(15%, -50%);
    background-color: white;
    transition: 0.4s;
    border-radius: 50%;
  }
`;

export const Switch = styled(Form.Label)`
  position: relative;
  display: inline-block;
  height: 30px;
  margin: 0;
  aspect-ratio: 2;

  input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  input:checked + ${Slider} {
    background-color: var(--primary);
  }

  input:checked + ${Slider}:before {
    left: 100%;
    transform: translate(-115%, -50%);
  }
`;

const TextMessage = styled.span`
  font-weight: normal;
  font-size: 14px;
  margin-top: 5px;
`;
